import React, { useEffect } from 'react';
import { useParams, useNavigate } from 'react-router-dom';
import { FiArrowLeft } from 'react-icons/fi';
import './TeamDetail.css';

const TeamDetail = ({ teamResults }) => {
  const { teamName } = useParams();
  const navigate = useNavigate();
  const decodedTeamName = decodeURIComponent(teamName);

  useEffect(() => {
    window.scrollTo(0, 0);
  }, [teamName]);

  const teamData = teamResults.filter(row => row && row['Team'] === decodedTeamName);
  
  if (teamData.length === 0) {
    return (
      <div className="team-detail">
        <div className="team-header">
          <button className="back-button" onClick={() => navigate(-1)}>
            <FiArrowLeft /> Back
          </button>
          <h1>{decodedTeamName}</h1>
        </div>
        <div className="no-data">No match results found for this team</div>
      </div>
    );
  }

  // Calculate aggregate stats
  const totalMatches = teamData.reduce((sum, row) => sum + parseInt(row['Matches']) || 0, 0);
  const totalWins = teamData.reduce((sum, row) => sum + parseInt(row['Won']) || 0, 0);
  const totalLosses = teamData.reduce((sum, row) => sum + parseInt(row['Lost']) || 0, 0);
  const overallWinPercent = totalMatches > 0 ? ((totalWins / totalMatches) * 100).toFixed(1) : '0';

  // Get unique formats and sort them
  const formats = [...new Set(teamData.map(row => row['Format']))].sort();

  // Group data by format
  const dataByFormat = {};
  formats.forEach(format => {
    dataByFormat[format] = teamData.filter(row => row['Format'] === format)
      .sort((a, b) => parseInt(b['Year']) - parseInt(a['Year']));
  });

  return (
    <div className="team-detail">
      <div className="team-header">
        <button className="back-button" onClick={() => navigate(-1)}>
          <FiArrowLeft /> Back
        </button>
        <h1>{decodedTeamName}</h1>
      </div>

      <div className="team-stats-container">
        <h2>Overall Performance</h2>
        <div className="team-stats-grid">
          <div className="stat-card">
            <div className="stat-label">Total Matches</div>
            <div className="stat-value">{totalMatches}</div>
          </div>
          <div className="stat-card highlight">
            <div className="stat-label">Wins</div>
            <div className="stat-value">{totalWins}</div>
          </div>
          <div className="stat-card">
            <div className="stat-label">Losses</div>
            <div className="stat-value">{totalLosses}</div>
          </div>
          <div className="stat-card">
            <div className="stat-label">Win %</div>
            <div className="stat-value">{overallWinPercent}%</div>
          </div>
        </div>
      </div>

      <div className="match-records">
        <h2>Match Records by Format</h2>
        {formats.map(format => (
          <div key={format} className="format-section">
            <h3 className="format-title">{format}</h3>
            <div className="records-table-container">
              <table className="records-table">
                <thead>
                  <tr>
                    <th>Year</th>
                    <th>Matches</th>
                    <th>Won</th>
                    <th>Lost</th>
                    <th>Win %</th>
                  </tr>
                </thead>
                <tbody>
                  {dataByFormat[format].map((row, idx) => (
                    <tr key={idx} className={idx % 2 === 0 ? 'even' : 'odd'}>
                      <td>{row['Year']}</td>
                      <td>{row['Matches']}</td>
                      <td className="highlight">{row['Won']}</td>
                      <td>{row['Lost']}</td>
                      <td>{row['Win %']}</td>
                    </tr>
                  ))}
                </tbody>
              </table>
            </div>
          </div>
        ))}
      </div>
    </div>
  );
};

export default TeamDetail;
